import { render, staticRenderFns } from "./productRulesIndex.pug?vue&type=template&id=77d8099b&lang=pug&"
import script from "./productRulesIndex.ts?vue&type=script&lang=ts&"
export * from "./productRulesIndex.ts?vue&type=script&lang=ts&"
import style0 from "./productRulesIndex.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports